<template>
  <ValidationObserver
    v-slot="{
      invalid
    }"
    :class="$style.wrapper"
    tag="div"
  >
    <AdministratorSidebarController
      v-bind="$attrs"
      :invalid="invalid"
      v-on="$listeners"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate3';
import AdministratorSidebarController from './AdministratorSidebarController.vue';

export default {
  name: 'AdministratorSidebarWrapper',
  components: {
    AdministratorSidebarController,
    ValidationObserver,
  },
};
</script>

<style module>
.wrapper {
  height: 100%;
  overflow: hidden;
}
</style>
